__turbopack_context__.v({
  "root": "dKKx0G_root",
  "text___5NnZu": "dKKx0G_text___5NnZu",
});
